import { getTemplate } from "../template-helper";
import { translateElement, tr } from "../../util/locales" ;
import { waiter } from "../../util/utils";
import { getSavePatch } from "../binding";
import { info } from "../../util/dialogs";

const COMPONENT_NAME = "z-button-email" ;

const TEMPLATE_ID = "component-"+COMPONENT_NAME+"-template" ;
const TEMPLATE_URL = "/static/libs/components/"+COMPONENT_NAME+".html" ;

export default function register(){
    getTemplate(TEMPLATE_ID, TEMPLATE_URL).then((template)=>{
        
        class ButtonEmailComponent extends HTMLElement {
            constructor() {
                super();
                this.button = this.querySelector("button") ;
                if(!this.button){
                    const innerHtml = this.innerHTML ;
                    this.innerHTML = "" ;
                    const clone = document.importNode(template.content, true);
                    this.appendChild(clone);
                    translateElement(this) ;
                    this.button = this.querySelector("button") ;
                    if(innerHtml){
                        this.button.innerHTML = innerHtml ;
                    }
                }

                
                this.addEventListener("click", ()=>{
                    this.onSendEmail() ;
                }) ;
            }

            get disabled() {
                return this.button.getAttribute("disabled") ;
            }
            
            set disabled(disabled) {
                this.button.setAttribute("disabled", disabled) ;
            }

            static get observedAttributes() {
                return ['disabled'];
            }

            attributeChangedCallback(name, oldValue, newValue) {
                switch (name) {
                    case 'disabled':
                        this.disabled = newValue ;
                    break;
                }
            }

            onSendEmail(){
                const {data} = getSavePatch(this) ;

                const templateCode = this.getAttribute("z-template") ;
                const templateLang = this.getAttribute("z-lang") ;
                waiter(
                    window.restApi.list("_mail_templates", [{code: templateCode}]).then((templates)=>{
                        if(templates.length === 0){
                            throw tr("templates.thisTemplateDoesNotExist", {code: templateCode}) ;
                        }
                        data.server___host = window.location.host ;
                        data.__app_code = window.APP.name ;
                        return window.restApi.create("_mail_queue", {
                            status: "tosend", 
                            template_code: templateCode,
                            template_params: data,
                            lang: templateLang||null,
                            create_date: new Date()
                        });
                    })
                ).then(()=>{
                    info(tr("templates.emailSent")) ;
                }) ;
            }
        }
        customElements.define(COMPONENT_NAME, ButtonEmailComponent);
    }).catch((err)=>{
        throw err ;
    }) ;
}
